import { not } from '../util/not';
import { filter } from '../operators/filter';
import { innerFrom } from './innerFrom';
export function partition(source, predicate, thisArg) {
    return [filter(predicate, thisArg)(innerFrom(source)), filter(not(predicate, thisArg))(innerFrom(source))];
}
//# sourceMappingURL=partition.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/observable/partition.js
// module id = 1193
// module chunks = 0